module.exports = __webpack_public_path__ + "img/video.6c7da288.png";